module.exports = __webpack_public_path__ + "static/media/fa-qs-icon-active.28e4d88a.svg";